import React from 'react'
import styled from 'styled-components/macro'
import { FOOD_SAFETY_SURFACE } from 'src/constants/foodSafety'
import {
  foodSafetyClockSlots,
  foodSafetyTimeDigits,
  formatFoodSafetyTimeEntry,
} from 'src/utils/foodSafetyTime'

/**
 * 24-hour time. The colon is always in the box, the way °C sits beside a
 * temperature. Empty slots read as underscores. Digits only; "1430" saves.
 */
const FoodSafetyClockField = ({
  id,
  value,
  onChange,
  onPressEnter,
  hasError = false,
  'aria-label': ariaLabel,
  'data-testid': testId,
}) => {
  const slots = foodSafetyClockSlots(value)
  return (
    <Shell $error={hasError}>
      <Mask aria-hidden='true'>
        <Slot $filled={slots[0] !== '_'}>{slots[0]}</Slot>
        <Slot $filled={slots[1] !== '_'}>{slots[1]}</Slot>
        <Colon>:</Colon>
        <Slot $filled={slots[2] !== '_'}>{slots[2]}</Slot>
        <Slot $filled={slots[3] !== '_'}>{slots[3]}</Slot>
      </Mask>
      <DigitInput
        id={id}
        value={foodSafetyTimeDigits(value)}
        onChange={e => onChange(formatFoodSafetyTimeEntry(e.target.value))}
        onKeyDown={e => {
          if (onPressEnter && e.key === 'Enter' && !e.shiftKey) {
            onPressEnter(e)
          }
        }}
        inputMode='numeric'
        autoComplete='off'
        maxLength={4}
        aria-label={ariaLabel}
        data-testid={testId}
      />
    </Shell>
  )
}

const Shell = styled.div`
  position: relative;
  width: 6.75rem;
  min-height: 2.5rem;
  border: 1.5px solid
    ${({ $error }) =>
      $error
        ? FOOD_SAFETY_SURFACE.STATUS_ATTENTION
        : FOOD_SAFETY_SURFACE.HERO_BORDER};
  border-radius: ${FOOD_SAFETY_SURFACE.CONTROL_RADIUS};
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Mask = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`

const Slot = styled.span`
  width: 1rem;
  text-align: center;
  font-size: 1.125rem;
  font-weight: ${({ $filled }) => ($filled ? 700 : 400)};
  color: ${({ $filled }) => ($filled ? '#1a1a1a' : '#6b6b6b')};
`

const Colon = styled.span`
  width: 0.625rem;
  text-align: center;
  font-size: 1.125rem;
  font-weight: 700;
`

const DigitInput = styled.input`
  position: absolute;
  inset: 0;
  opacity: 0;
  width: 100%;
  cursor: text;
  font-size: 1.125rem;
`

export default FoodSafetyClockField
